import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Background from "@/components/site/Background";
import CookieBanner from "@/components/site/CookieBanner";
import CommandPalette from "@/components/site/CommandPalette";
import BackToTop from "@/components/site/BackToTop";
import AIAssistant from "@/components/site/AIAssistant";
import SmoothScroll from "@/components/site/SmoothScroll";

export default function SiteLayout() {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    // On non-home routes, hero-ready never fires — mark ready right after mount.
    if (location.pathname !== "/") {
      try { window.__RL_HERO_READY = true; } catch (e) {}
    }
  }, [location.pathname]);

  useEffect(() => {
    const on = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", on);
    return () => window.removeEventListener("keydown", on);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-white text-[#0B0B10] theme-editorial-global">
      <SmoothScroll />
      <Header onOpenPalette={() => setPaletteOpen(true)} />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
      <CookieBanner />
      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      <AIAssistant />
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(11,11,16,0.10)",
            color: "#0B0B10",
          },
        }}
      />
    </div>
  );
}
